import React from "react";
import classes from "./Loader.module.css";
import loader from "../../assets/gif/loader.gif";

const Loader = () => {
  return (
    <div className={classes.loader}>
      <img src={loader} alt="loader gif file" />
    </div>
  );
};

export default Loader;
